<template>
  <v-card class="programatic-content" :level="1" heading="Conteúdo Programático" v-if="contents.e1 || contents.e4">
    <p>Veja o conteúdo programático dos módulos E1 e E4</p>
    <span @click="current = 'e1'" v-if="contents.e1">
      <span >Módulo E1</span>
      <i class="icon-eye"></i>
    </span>
    <span @click="current = 'e4'" v-if="contents.e4">
      <span>Módulo E4</span>
      <i class="icon-eye"></i>
    </span>
    <v-lightbox @close="current = null" :active="current != null">
      <body-text v-html="this.contents[current]" />
    </v-lightbox>
  </v-card>
</template>

<script>
import Card from '@/components/layout/Card.vue';
import Lightbox from '@/components/layout/Lightbox.vue';
import BodyText from '@/components/uikit/text/BodyText.vue';

export default {
  name: 'ProgramaticContent',
  components: {
    'v-card': Card,
    'v-lightbox': Lightbox,
    'body-text': BodyText,
  },
  props: {
    contents: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      current: null,
    };
  },
};
</script>

<style lang="scss" scoped>
$component: '.programatic-content';
#{$component} {
  padding: 0;
  border: 1px solid $color-sys-h;
  /deep/ .card__title {
    background-color: $color-d;
  }
  p {
    margin: 0;
    padding: $gutter-l;
    border-bottom: 1px solid $color-sys-h;
    font-size: $font-size-l;
  }
  > span {
    box-sizing: border-box;
    padding: $gutter $gutter-l;
    margin: $gutter 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    font-size: $font-size-l;
    font-weight: $font-weight-heavy;
    text-decoration: none;
    color: $color-sys-f;
    transition: color $transition-duration $transition-timing-function;
    cursor: pointer;
    span {
      padding-right: $gutter-l;
      color: inherit;
    }
    i {
      color: inherit;
    }
    &:hover {
      color: $color-sys-b;
    }
  }
}
</style>
